<template>
    <div class="columns is-multiline">
        <div class="column is-half has-text-left">
            <b-field label="Fecha de retiro*">
                <b-datepicker
                    inline
                    v-model="date"
                    locale="es-ES"
                    :years-range="yearsRange"
                    :unselectable-days-of-week="unselectableDays"
                    :min-date="minDateAlgo"
                    :max-date="maxDateAlgo"
                    placeholder="Click para seleccionar"
                    icon="calendar-today"
                    trap-focus
                    @input="dateSelected">
                </b-datepicker>
            </b-field>
            
        </div>
        <div class="column is-half has-text-left">
            <b-field label="Hora de retiro*">
                <b-timepicker
                inline
                default-minutes="0"
                hour-format="24"
                v-model="time"
                :disabled="disabledTimePicker"
                increment-minutes="30"
                :min-time="minTimeAlgo"
                :max-time="maxTimeAlgo"
                @input="timeSelected"
                >
                </b-timepicker>
            </b-field>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            openingTime:8,
            closingTime:18,
            date:"",
            time:"",
            unselectableDays:[0,6],
            yearsRange:[0,0],
            maxDaysInFuture:15
        }
    },
    methods:{
        dateSelected(){
            console.log(this.date)
            this.time = ""
            this.$emit("dateDone", {date:"", barrio:""})
        },
        timeSelected(){
            console.log("fecha",this.date)
            console.log(this.time.getTime())
            this.date.setHours(this.time.getHours())
            console.log("fecha2",this.date)
            this.$emit("dateDone", {date:this.date, barrio:""})
        }
    },
    computed:{
        disabledTimePicker(){
            if(this.date == ""){
                return true
            }
            return false
        },
        minDateAlgo(){
            var now = new Date()
            //now.addHours(2)
            //var actualMinHours = now.getHours()
            //var deliveryMargin = this.closingTime - actualMinHours 
            //if(deliveryMargin >= 2){
            //    now.setDate(now.getDate() - 1)
            //}
            
            if (now.getDay() == 6 ){
                now.setDate(now.getDate() + 2);
            } 
            else if(now.getDay() == 0 ){
                now.setDate(now.getDate() + 1)
            }
            return now
        },
        maxDateAlgo(){
            var now = new Date()
            var limit = new Date("02/08/2021")
            var timeDiff = limit.getTime() - now.getTime()
            var days = timeDiff / (1000 * 3600 * 24);
            if(days > this.maxDaysInFuture){
                now.setDate(now.getDate() + this.maxDaysInFuture)
            } else if (days <= 0){
                return now
            } else {
                now.setDate(now.getDate() + days)
            }
            console.log(days)
            console.log(now)

            return now
        },
        minTimeAlgo(){
            var manana = [0,1,2,3,4,5,6,7,8,9,10,11,12]
            var tarde = [13,14,15,16,17,18,19,20,21,22,23,24]
            var now = new Date()
            var todayDate = now.getDate()
            //if(this.date != '' && this.date.getDate() === todayDate){
            //    now.setHours(now.getHours()+2)
            //    return now
            //}
            var actualHour = now.getHours()
            if (manana.includes(actualHour)){
                now.setHours(this.openingTime)
            } 
            else if (tarde.includes(actualHour)){
                now.setHours(12)
            } 
            
            return now
        },
        maxTimeAlgo(){
            var now = new Date()
            now.setHours(this.closingTime)
            return now
        }
    }
}
</script>